import {lazy} from 'react';
import GenericFallbackSuspense from '../../../ui/GenericFallback/GenericFallbackSuspense';

const PayVyneOverlayBody = lazy(() => import('./PayVyneOverlayBody'/* webpackChunkName: 'PayVyneOverlayBody' */));

export default function PayVyneOverlayLazyLoader() {
  return (
    <GenericFallbackSuspense>
      <PayVyneOverlayBody />
    </GenericFallbackSuspense>
  );
}
